import { propIn } from '../../../common/utils/immutableHelper';

export const getDeletedElements = propIn(['deletedElements']);

/**
 * Returns whether the element has been deleted during the current client session.
 */
export const selectIsElementDeleted = (state: any, elementId: string): boolean =>
    !!getDeletedElements(state)?.[elementId];
